export default class REST {
    constructor() {
        this.global = {
            hostname: 'https://krzyzkrakow.pl/wp-json',
            routes: {
                fromArtistsLife: '/dev/v1/artists/life',
                gospelForArtists: '/dev/v1/artists/gospel',
                calendar: '/dev/v1/artists/calendar',
                movies: '/dev/v1/artists/movies',
                fromChurchLife: '/dev/v1/churchlife',
                settings: '/dev/v1/artists/settings',
                getPost: '/wp/v2/posts/'
            }
        }
    }

    getEndpoint(route) {
        return `${this.global.hostname}${route}`;
    }

    async getStatus() {
        const response = await fetch(this.getEndpoint(this.global.routes.settings), {});
        const status = await response.ok;

        return status;
    }

    async getSettings() {
        const response = await fetch(this.getEndpoint(this.global.routes.settings), {});
        const json = await response.json();

        let data = json;

        return data;
    }
    
    async getFromArtistsLife() {
        const response = await fetch(this.getEndpoint(this.global.routes.fromArtistsLife), {});
        const json = await response.json();

        let data = [];

        json.forEach(entry => {
            data.push({
                content: entry.content,
                id: entry['ID'],
                tag: entry.tag,
                thumbnail: entry.thumbnail ? entry.thumbnail : '',
                timestamp: entry.timestamp,
                title: entry.title
            })
        })

        return data;
    }

    async getGospelForArtists() {
        const response = await fetch(this.getEndpoint(this.global.routes.gospelForArtists), {});
        const json = await response.json();

        let data = [];

        json.forEach(entry => {
            data.push({
                content: entry['post_content'],
                date: new Date(entry['post_date']),
                id: entry['ID'],
                shortage: entry['post_excerpt'],
                slug: entry['post_name'],
                title: entry['post_title']
            })
        })

        return data;
    }

    async getCalendar() {
        const response = await fetch(this.getEndpoint(this.global.routes.calendar), {});
        const json = await response.json();

        let data = json;

        return data;
    }

    async getMovies() {
        const response = await fetch(this.getEndpoint(this.global.routes.movies), {});
        const json = await response.json();

        let data = json;

        return data;
    }

    async getFromChurchLife() {
        const response = await fetch(this.getEndpoint(this.global.routes.fromChurchLife), {});
        const json = await response.json();

        let data = json;

        return data;
    }

    async getPost(ID = "") {
        const response = await fetch(`${this.getEndpoint(this.global.routes.getPost)}${ID}`, {});
        const json = await response.json();

        let data = json;

        return data;
    }
}